export default __webpack_public_path__ + "static/media/contrato2.6df9a85c.jpg";